module.exports = __webpack_public_path__ + "img/B.ba61d8f1.gif";